import ENV from "../env";
import getAuthHeaders from "./authHeaders";

const createCustomer = async (details) => {
  const headers = await getAuthHeaders();
  
  const response = await fetch(
    `${ENV.firebaseApiUrl}/customer/create`,
    {
      method: "POST",
      headers,
      body: JSON.stringify({
        customer: details,
      }),
    }
  );

  const resData = await response.json();

  if (!response.ok) {
    throw new Error("Create customer failed: " + resData.message);
  }

  return resData.customerId;
};

export default createCustomer;